import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    accidentStatistic: [],
    branchStatistic: [],
    injuryStatistic: [],
    evacuatedStatistic: {},
    responseStatistic: [],
    hoursStatistic: [],
    cardStatistic: {},
    transportStatistic: [],
    loadingStatus: 'idle',
    error: null
}

export const fetchAccidents = createAsyncThunk(
    'statistic/fetchAccidents',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/emergency-types-distribution?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchBranch = createAsyncThunk(
    'statistic/fetchBranch',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/emergencies-per-branch-office?${params}`,
                'GET',
                null,
                customHeaders
            );

            console.log("API Response:", response.data);
            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

export const fetchInjury = createAsyncThunk(
    'statistic/fetchInjury',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/injury-counts-per-emergency-type?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchEvacuated = createAsyncThunk(
    'statistic/fetchEvacuated',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/evacuated-people-medical-aid?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchResponse = createAsyncThunk(
    'statistic/fetchResponse',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/response-time-per-emergency-type?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchHours = createAsyncThunk(
    'statistic/fetchHours',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/worker-man-hours-per-emergency?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchCard = createAsyncThunk(
    'statistic/fetchCard',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/card-statistics?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)

export const fetchTransport = createAsyncThunk(
    'statistic/fetchTransport',
    async({token, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/statistics/transport-usage?${params}`,
                'GET',
                null,
                customHeaders
            );

            return {
                data: response.data
            }
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
)


const statisticSlice = createSlice({
    name: 'statistic',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccidents.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchAccidents.fulfilled, (state, action) => {
                state.accidentStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchAccidents.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchBranch.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchBranch.fulfilled, (state, action) => {
                state.branchStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchBranch.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchInjury.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchInjury.fulfilled, (state, action) => {
                state.injuryStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchInjury.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchEvacuated.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchEvacuated.fulfilled, (state, action) => {
                state.evacuatedStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchEvacuated.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchResponse.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchResponse.fulfilled, (state, action) => {
                state.responseStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchResponse.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchHours.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchHours.fulfilled, (state, action) => {
                state.hoursStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchHours.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchCard.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchCard.fulfilled, (state, action) => {
                state.cardStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchCard.rejected, (state) => {
                state.loadingStatus = 'error';
            })
            .addCase(fetchTransport.pending, (state) => {
                state.loadingStatus = 'loading'
            })
            .addCase(fetchTransport.fulfilled, (state, action) => {
                state.transportStatistic = action.payload.data;
                state.links = action.payload.links
                state.loadingStatus = 'idle';
            })
            .addCase(fetchTransport.rejected, (state) => {
                state.loadingStatus = 'error';
            })
    }
});

export default statisticSlice.reducer;